import { HttpErrorResponse } from '@angular/common/http';
import { UUID } from 'angular2-uuid';
import { Observable, Subject, } from 'rxjs';
import { ITemplate } from './i-template';

/** 取模板資料服務抽象類 */
export abstract class AbstractTemplateService<T extends ITemplate> {
  /** 模板設定資料 */
  protected _template: T;
  /** 模板設定資料 */
  get template(): T { return this._template; }
  /** 錯誤處理方法，向後台模板服務註冊後回塞 */
  _errorHandler: <U extends unknown>(error: HttpErrorResponse, observableFunc: (args?: any) => Observable<U>) => Observable<any>;
  /** 提交模板區塊設定 */
  abstract updateTemplate(): Observable<T>;

  private move(from: number, to: number): number {
    const sections = this._template.sections;
    if (to < 0 || to >= sections.length) {
      return from;
    }

    const section = sections[from];
    sections.splice(from, 1);
    sections.splice(to, 0, section);

    return to;
  }

  /** 移動區塊順序 */
  moveSection(uuid: string, direction: boolean) {
    const sections = this._template.sections;
    const index = sections.findIndex((section) => section.data.uuid === uuid);
    direction ? this.move(index, index - 1) : this.move(index, index + 1);

    sections.forEach((section, i) => {
      section.data.index = i;
    });
  }

  /** 增加區塊 */
  addSection(sectionUUID: string) {
    const index = this._template.sections.findIndex((section) => section.data.uuid === sectionUUID);
    const section = this._template.sections[index];
    this._template.sections.splice(index + 1, 0, {
      selector: section.selector,
      data: {uuid: UUID.UUID(), enable: true, cannotDel: false, needScroll: true}
    });
  }

  /** 刪除區塊 */
  rmSection(sectionUUID: string) {
    const index = this._template.sections.findIndex((section) => section.data.uuid === sectionUUID);
    this._template.sections.splice(index, 1);
  }
}
